
import { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import MediaSharingControls from "./MediaSharingControls";
import PrivateAlbumsSection from "@/components/privateAlbums/PrivateAlbumsSection";
import { useParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

const MediaRibbon = () => {
  const { matchId } = useParams<{ matchId: string }>();
  const { user } = useAuth();
  
  const [partnerName, setPartnerName] = useState("your match");

  const parseMatchId = (matchId: string): string[] => {
    if (matchId.length < 73) return [];
    
    const firstUuidEnd = 36;
    const user1Id = matchId.substring(0, firstUuidEnd);
    const user2Id = matchId.substring(firstUuidEnd + 1);
    
    return [user1Id, user2Id];
  };

  useEffect(() => {
    if (user && matchId) {
      fetchPartnerName();
    }
  }, [user, matchId]);

  const fetchPartnerName = async () => {
    if (!user || !matchId) return;

    try {
      const userIds = parseMatchId(matchId);
      const otherUserId = userIds.find(id => id !== user.id);
      if (!otherUserId) return;

      const { data: profile } = await supabase
        .from('user_profiles')
        .select('display_name, first_name, last_name')
        .eq('user_id', otherUserId)
        .single();

      if (profile) {
        const name = profile.display_name || 
                    `${profile.first_name || ''} ${profile.last_name || ''}`.trim() || 
                    'your match';
        setPartnerName(name);
      }
    } catch (error) {
      console.error('Error fetching partner name:', error);
    }
  };

  const handleSharingStatusChange = () => {
    // Refresh functionality for media sharing controls if needed
  };

  return (
    <ScrollArea className="h-full">
      <div className="p-4 space-y-4">
      {/* Media Sharing Controls */}
      {matchId && (
        <Card>
          <CardContent className="p-4">
            <MediaSharingControls 
              matchId={matchId}
              partnerName={partnerName}
              onSharingStatusChange={handleSharingStatusChange}
            />
          </CardContent>
        </Card>
      )}


        {/* Private Albums Section */}
        <PrivateAlbumsSection />
      </div>
    </ScrollArea>
  );
};

export default MediaRibbon;
